<div class="container mt-4">
  <h1 class="h1 title-blue-h1-cap">Lista de asistencia</h1>
  <hr />
  <div class="container my-div shadow-sm">
    <br />
    <div class="text-center">
      <h1 class="fw-bold">
        {{ selectedCourseSession?.IdLocalizador }} -
        {{ selectedCourseSession?.titulo }}
      </h1>
    </div>
    <div class="container">
      <div class="my-div">
        <table class="table table-responsive-container">
          <tbody>
            <!-- 1 locator id and event name -->
            <tr>
              <td class="fw-bold">ID localizador:</td>
              <td>{{ selectedCourseSession?.IdLocalizador }}</td>
              <td class="fw-bold">Evento:</td>
              <td>{{ selectedCourseSession?.nombreEvento }}</td>
              <td rowspan="3" class="align-items-center">
                <!-- select session part -->
                <mat-form-field style="width: 250px" class="mx-1">
                  <mat-label>Seleccionar D&iacute;a</mat-label>
                  <mat-select
                    [disabled]="!selectedCourseSession"
                    [(value)]="selectedSession"
                    (selectionChange)="onChange()">
                    <mat-option [value]="-1">
                      Todos los d&iacute;as
                    </mat-option>
                    <mat-option
                      *ngFor="let session of sessions"
                      [value]="session.value">
                      {{ session.showValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <button
                  type="button"
                  mat-icon-button
                  ngbTooltip="Actualizar"
                  (click)="updateData()">
                  <mat-icon>update</mat-icon>
                </button>
              </td>
            </tr>

            <!-- 4 creation date -->
            <tr>
              <td class="fw-bold d-flex align-items-center">
                Fecha de inicio:
              </td>
              <td>
                {{
                  selectedCourseSession?.fechaInicio
                    | date: "dd-MMM-yyyy" : "" : "es-MX"
                }}
              </td>
              <td class="fw-bold d-flex align-items-center">Compartido por:</td>
              <td>
                {{ user?.name ?? "-" }}
              </td>
            </tr>

            <!-- 3 master qr -->
            <tr>
              <td class="fw-bold d-flex align-items-center">QR maestro:</td>
              <td>{{ selectedCourseSession?.QrMeastro ? "Sí" : "No" }}</td>
              <td class="fw-bold d-flex align-items-center">Partes:</td>
              <td class="truncate-text">
                {{ selectedCourseSession?.totalPartesReales }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <mat-card-content class="px-5">
        <div style="width: 100%; overflow-x: auto; min-width: 600px">
          <ng-container *ngIf="isAssistanceLoading; else showData">
            <app-loading-spinner></app-loading-spinner>
          </ng-container>
          <ng-template #showData>
            <ng-container
              *ngIf="
                reporteAsistenciasSessions &&
                  reporteAsistenciasSessions.participantes.length > 0;
                else noData
              ">
              <div
                style="min-height: 350px"
                class="table-responsive-container mt-3">
                <table
                  matSort
                  mat-table
                  (matSortChange)="sortData($event)"
                  [dataSource]="dataSource"
                  class="mat-elevation-z8"
                  aria-describedby="assistance-report">
                  <ng-container matColumnDef="code">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Número de Colaborador
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.numeroPersona }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Nombre
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ getFullName(element) }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="curp">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      CURP
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.curp ?? "-" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Email
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.email ?? "-" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Fecha asistencia
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.fechaRegistro
                          | date: "dd/MM/yyyy" : "" : "es-mx"
                          | titlecase
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="numeroSesion">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Total de asistencias
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="attendance-flex">
                        <span class="attendance-text">
                          {{
                            selectedCourseSession?.QrMeastro
                              ? reporteAsistenciasSessions.numeroTotalPartesSesion
                              : element.numeroSesion ?? "-"
                          }}
                          de
                          {{
                            reporteAsistenciasSessions.numeroTotalPartesSesion
                          }}
                        </span>
                        <!--
                    <button *ngIf="showsAllSessionsAttendance"
                            type="button"
                            mat-icon-button
                            ngbTooltip="Ver detalle">
                      <mat-icon>visibility</mat-icon>
                    </button>
                      --></div>
                    </td>
                  </ng-container>
                  <ng-container
                    matColumnDef="missingParts"
                    *ngIf="showMissingPartsColumn">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Partes faltantes
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <span class="px-3">
                        {{
                          element.partesFaltantes &&
                          element.partesFaltantes !== ""
                            ? element.partesFaltantes
                            : "-"
                        }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      Estatus
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        getStatusInfoByNumber(element.idSesionAsistenciaEstatus)
                      }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </div>
            </ng-container>
            <ng-template #noData>
              <div
                class="d-flex flex-column align-items-center mb-2 mt-3 text-center"
                *ngIf="errorOnGetAttendance">
                <div>
                  <h3 class="form-text text-danger mt-3">
                    Ha ocurrido un error al cargar los datos
                  </h3>
                </div>
              </div>
              <app-no-data-msg></app-no-data-msg>
            </ng-template>
          </ng-template>
        </div>
      </mat-card-content>
      <br />

      <mat-paginator
        [pageSizeOptions]="[10, 20, 50, 100]"
        [pageSize]="selectedPageSize"
        (page)="onPageSizeChange($event)"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <!-- Buttons -->
  <hr />
  <div class="row d-flex justify-content-center mt-4">
    <div class="col-md-2 col-sm-6 col-12 mx-3">
      <button
        id="btn-cancel-newplan"
        class="btn btn-secondary-cap"
        style="max-width: 250px"
        [routerLink]="['/myQrs']"
        routerLinkActive="router-link-active">
        Cerrar
      </button>
    </div>
  </div>
</div>
